// extracted by mini-css-extract-plugin
export default {"content_container":"AddCasePopup_content_container__Nfiap","error_container":"AddCasePopup_error_container__+5ZrX","error_text":"AddCasePopup_error_text__1a0e3"};